import { StartPageLayout } from "@pages/start/layout/layout";
import { createFileRoute } from "@tanstack/react-router";

type StartSearch = {
  o: string;
};

export const Route = createFileRoute("/start")({
  component: StartPageLayout,
  validateSearch: (search: Record<string, unknown>): StartSearch => {
    return {
      o: (search.o as string) || "",
    };
  },
});
